import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { AtualizacoesAudit } from 'src/app/modules/projeto-completo/models/atualizacoes-audit';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { QrObra } from '../../models/qr-obra.model';
import { QrObrasService } from '../../services/qr-obra-service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-obras-edit',
  templateUrl: './obras-edit.component.html',
  styleUrls: ['./obras-edit.component.scss']
})
export class ObrasEditComponent extends BaseFormComponent<QrObra> implements OnInit {

  obra: QrObra;
  list: any;
  listUsuario: any[];
  audit: any;
  canSave: boolean = true;
  infoProjeto: any;
  countResponsavel: number = 1;
  entidade:number|null = null;

  constructor(
    private myService: QrObrasService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private navigation: NavigationService,
    private authService: AuthService
  ) {
    super(activatedRoute)
  }

  async ngOnInit(): Promise<void> {
    this.list = this.activatedRoute.snapshot.data['list'];
    this.entity = this.activatedRoute.snapshot.data['entity'];
    this.infoProjeto = this.activatedRoute.snapshot.data['projeto'];
    this.entidade = await this.authService.getSession();

    if (this.entity?.name_resp_2) {
      this.countResponsavel = 2;
    }
    if (this.entity?.name_resp_3) {
      this.countResponsavel = 3;
    }

    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
      description: new FormControl(''),
      global_value: new FormControl('', [Validators.required]),
      agency_id: new FormControl(null, [Validators.required]),
      project_full_id: new FormControl({ value: null, disabled: true }),
      pf_prt_issue_id: new FormControl({ value: null, disabled: true }),
      project_full_title: new FormControl({ value: null, disabled: true }),
      pf_prt_issue_title: new FormControl({ value: null, disabled: true }),
      manager: new FormControl(null),
      adjunct: new FormControl(null),
      work_city: new FormArray([new FormControl(null, [Validators.required])]),
      work_city_ben: new FormArray([new FormControl(null)]),
      work_latlng: new FormArray([]),
      map_gov_id: new FormControl(null),
      code: new FormControl(null),
      name_exec: new FormControl(null, [Validators.required]),
      doc_exec: new FormControl(null),
      name_resp: new FormControl(null, [Validators.required]),
      register_resp: new FormControl(null, [Validators.required]),
      name_resp_2: new FormControl(''),
      register_resp_2: new FormControl(''),
      name_resp_3: new FormControl(''),
      register_resp_3: new FormControl(''),
      name_supervisor: new FormControl(''),
      register_supervisor: new FormControl(null),
      status_id: new FormControl(null, [Validators.required]),
      dt_ini_goal: new FormControl(null),
      dt_ini_done: new FormControl(null),
      dt_paralyzed: new FormControl(null),
      ds_paralyzed: new FormControl(null),
      perc_exec: new FormControl(null),
      situation: new FormControl(null),
    });

    if (this.entity?.id) {
      this.form.patchValue(this.entity);
      this.actionLabel = 'Editar';
      this.canSave = this.entity?.can_save;

      if (this.entity?.work_city?.length) {
        this.getFormArray('work_city').clear();
        this.entity?.work_city?.forEach((item) => {
          this.getFormArray('work_city').push(new FormControl(item?.city_id, [Validators.required]));
        })
      }

      if (this.entity?.work_city_ben?.length) {
        this.getFormArray('work_city_ben').clear();
        this.entity?.work_city_ben?.forEach((item) => {
          this.getFormArray('work_city_ben').push(new FormControl(item?.city_id));
        })
      }

      this.entity?.work_latlng?.forEach((item) => {
        this.getFormArray('work_latlng').push(this.createFormGroup(item))
      })

      this.audit = {
        work_id: this.entity.id
      };

      if (this.entity?.readonly) {
        this.form.disable();
      }

    } else if (this.infoProjeto) {
      this.form.get('project_full_id').setValue(this.infoProjeto?.project_full_id);
      this.form.get('pf_prt_issue_id').setValue(this.infoProjeto?.pf_prt_issue_id);
      this.form.get('project_full_title').setValue(this.infoProjeto?.project_full_title);
      this.form.get('pf_prt_issue_title').setValue(this.infoProjeto?.pf_prt_issue_title);
    }
  }

  createFormGroup(values = null): FormGroup {
    return new FormGroup({
      id: new FormControl(values?.id),
      lat: new FormControl(values?.lat, [Validators.required]),
      lng: new FormControl(values?.lng, [Validators.required]),
    });
  }

  getFormArray(field: string): FormArray {
    return this.form.get(field) as FormArray;
  }

  addLagLng() {
    this.getFormArray('work_latlng').push(this.createFormGroup());
  }

  addField(field: string) {
    this.getFormArray(field).push(new FormControl(null, field === 'work_city' ? [Validators.required] : []));
  }

  removeField(index: number, field: string) {
    this.getFormArray(field).removeAt(index);
  }

  getDataCreate(): QrObra {
    let data: QrObra;
    data = Object.assign({}, data, this.form.value);

    if (data.global_value != '0') {
      data.global_value = data.global_value?.toString().replace('.', ',');
    }

    let formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (data.dt_ini_goal && !formatoDataRegex.test(data.dt_ini_goal)) {
      data.dt_ini_goal = formatDate(data.dt_ini_goal, 'DD/MM/YYYY');
    }
    if (data.dt_ini_done && !formatoDataRegex.test(data.dt_ini_done)) {
      data.dt_ini_done = formatDate(data.dt_ini_done, 'DD/MM/YYYY');
    }
    if (data.dt_paralyzed && !formatoDataRegex.test(data.dt_paralyzed)) {
      data.dt_paralyzed = formatDate(data.dt_paralyzed, 'DD/MM/YYYY');
    }

    if (!this.entity?.id && this.infoProjeto) {
      if (this.activatedRoute.snapshot.queryParams["project_full_id"]) {
        data.project_full_id = this.infoProjeto?.project_full_id;
      } else if (this.activatedRoute.snapshot.queryParams["pf_prt_issue_id"]) {
        data.pf_prt_issue_id = this.infoProjeto?.pf_prt_issue_id;
      }
    }

    return data;
  }

  salvar(): void {
    if (this.form.valid && this.dataFormValid('dt_ini_goal', 'dt_ini_done')) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res) => {
              this.msgSuccess('Obra alterada com sucesso!');
              EventSharedService.get('auditRefresh').emit();
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res) => {
              this.confirmation().subscribe(() => {
                this.navigation.replace(['/qrobras', 'obra', res.id]);
              })
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
      this.getFormArray('work_latlng').controls.forEach((form, index) => {
        Object.keys(form['controls']).forEach((key) => this.getFormArray('work_latlng').controls[index]['controls'][key].markAsDirty());
      })
      this.getFormArray('work_city').controls.forEach((form) => {
        form.markAsDirty();
      })
    }
  }

  dataMask(event, field) {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9/]/g, '');
    this.form.get(field).setValue(sanitizedValue);
  }

  formatarMedidaFisica(field: string, decimalPlacesValue = 2) {
    let formValue = this.form.get(field)?.value;
    let value = this.maskService.formatarMedidaFisica(formValue, decimalPlacesValue);
    this.form.get(field).setValue(value);
  }

  fieldMessageRequireds(form, field, index: number) {
    return this.getFormArray(form).controls[index].get(field).invalid && this.getFormArray(form).controls[index].get(field).dirty;
  }

  fieldErrosFormArray(form, field, index: number) {
    return this.getFormArray(form).controls[index].get(field)?.errors;
  }

  fieldMessageRequireds2(form, index: number) {
    return this.getFormArray(form).controls[index].invalid && this.getFormArray(form).controls[index].dirty;
  }

  fieldErrosFormArray2(form, index: number) {
    return this.getFormArray(form).controls[index]?.errors;
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: (res) => {
        this.loaded();
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['/qrobras/pesquisa-geral']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error?.message)
      }
    });
  }

  voltar() {
    this.navigation.back(['qrobras', 'pesquisa-geral']);
  }

  addResponsavel() {
    this.countResponsavel += 1;
  }

  get qrCodeLink(): string{
    const host = window.location.hostname;
    var linkPre = '';
    if(host != 'localhost'){
      linkPre = 'obras.';
    }
    const link = linkPre + host + '/obra/' + this.entity?.code + '/' + this.entidade;
    return link ?? '';
  }

  downloadQrCode():void{
    const canvas = document.querySelector('qrcode canvas') as HTMLCanvasElement;
    const image = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = image;
    link.download = 'qrcode.png';
    link.click();
  }
}
